const filterPopUp = {
    _popUpNode: null,
    _openButton: null,
    _closeButton: null,
    _openCategoryPopUpReference: null,
    _closeCategoryPopUpReference: null,
    _closeListener: null,

    init() {
        let self = this;

        if(! document.querySelector('.js-filter-popup')) {
            return;
        }

        const scriptUrl = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js';

        window.initPackage(scriptUrl).then(() => {
            self.createListeners();
        }).catch((error) => {
            console.error(error);
        });
    },

    reInit() {
        let self = this;

        if(self._popUpNode && !self._popUpNode.classList.contains('hidden')) {
            self._closeCategoryPopUp(self);
        }
        if(self._openButton && self._closeButton) {
            self._destroyListeners();
        }
        
        self.init();
    },

    createListeners() {
        let self = this;
        
        self._popUpNode = document.querySelector('.js-filter-popup');

        self._openButton = document.querySelector('.js-filter-popup-button');
        self._closeButton = self._popUpNode.querySelector('.js-filter-close-button');

        self._openCategoryPopUpReference = self._openCategoryPopUp.bind(null, self);
        self._closeCategoryPopUpReference = self._closeCategoryPopUp.bind(null, self);

        self._openButton.addEventListener('click', self._openCategoryPopUpReference, false);
        self._closeButton.addEventListener('click', self._closeCategoryPopUpReference, false);   
    },

    _destroyListeners() {
        let self = this;
        if(self._openCategoryPopUpReference) {
            self._openButton.removeEventListener('click',  self._openCategoryPopUpReference, false);
        }

        if(self._closeCategoryPopUpReference) {
            self._closeButton.removeEventListener('click',  self._closeCategoryPopUpReference, false);
        }
    },

    _openCategoryPopUp(self) {
        self._popUpNode.classList.remove('hidden');
        gsap.from(self._popUpNode, {autoAlpha: 0, duration: 0.3, x: '100%'});
    },

    _closeCategoryPopUp(self) { 
        gsap.to(self._popUpNode, {autoAlpha: 0, duration: 0.3, x: '100%', delay: 0.1, onComplete:function(){
            self._popUpNode.removeAttribute('style');
            self._popUpNode.classList.add('hidden');
        }});
    }
};

filterPopUp.init();
document.addEventListener('LokiRequestEnd', function () {
    filterPopUp.reInit();
});
